import { useAuth } from "@/contexts/AuthContext"
import {
  APP_LOGIN_URL,
  APP_ONBOARDING_URL,
  APP_REGISTER_URL,
  APP_URL,
} from "@/lib/site"

type SessionUser = {
  role?: string
  onboardingStatus?: "pending" | "completed"
} | null

export function getAppHomePath(user?: SessionUser) {
  if (user && user.role !== "manager" && user.onboardingStatus === "pending") {
    return APP_ONBOARDING_URL
  }
  return APP_URL
}

export function useAppSession() {
  const { user, isAuthenticated, isLoading, currentStore } = useAuth()
  const signedIn = Boolean(isAuthenticated && user)
  const needsOnboarding =
    signedIn && user?.role !== "manager" && user?.onboardingStatus === "pending"
  const appPath = getAppHomePath(user)
  const startHref = signedIn ? appPath : APP_REGISTER_URL
  const startLabel = needsOnboarding ? "Finish setup" : "Open dashboard"

  return {
    user,
    signedIn,
    isLoading,
    currentStore,
    appPath,
    startHref,
    startLabel,
    loginHref: APP_LOGIN_URL,
    registerHref: APP_REGISTER_URL,
  }
}

/** Marketing conversion CTA that becomes a dashboard/setup link when signed in. */
export function useStartCta(guestLabel: string) {
  const session = useAppSession()
  return {
    ...session,
    href: session.startHref,
    label: session.signedIn ? session.startLabel : guestLabel,
  }
}
